/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProjectsInputs */

const en_nav_projects = /** @type {(inputs: Nav_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work`)
};

const lv_nav_projects = /** @type {(inputs: Nav_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbi`)
};

/**
* | output |
* | --- |
* | "Work" |
*
* @param {Nav_ProjectsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_projects = /** @type {((inputs?: Nav_ProjectsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProjectsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_projects(inputs)
	return en_nav_projects(inputs)
});